import { colors } from 'component-library/__styling/settings/colors'
import { PerthNowSections } from 'publication-types'
import { BaseSectionValues } from '.'

export type PerthNowSection = keyof typeof PerthNowSections

export interface PerthNowSectionValues extends BaseSectionValues {}

export type PerthNowSectionProps = { [section in PerthNowSection]: PerthNowSectionValues }

export const perthNowSectionDefinitions: PerthNowSectionProps = {
    default: {
        primaryColor: colors.perthnow.pinkThulite,
    },
    generic: {
        primaryColor: colors.perthnow.greyBasalt,
    },
    news: {
        primaryColor: colors.perthnow.blueSapphire,
    },
    classifieds: {
        primaryColor: colors.perthnow.blueKyanite,
    },
    sport: {
        primaryColor: colors.perthnow.redRuby,
    },
    entertainment: {
        primaryColor: colors.perthnow.purpleAmethyst,
    },
    business: {
        primaryColor: colors.perthnow.orangeAmber,
    },
    lifestyle: {
        primaryColor: colors.perthnow.pinkThulite,
    },
    video: {
        primaryColor: colors.perthnow.greenJade,
    },
    politics: {
        primaryColor: colors.perthnow.pinkThulite,
    },
    travel: {
        primaryColor: colors.perthnow.pinkThulite,
    },
    technology: {
        primaryColor: colors.perthnow.pinkThulite,
    },
    opinion: {
        primaryColor: colors.perthnow.pinkThulite,
    },
    'community-news': {
        primaryColor: colors.perthnow.blueCerulean,
    },
}
